import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {ButtonJoinConfigType} from 'TemplateEditor/Layout/Blocks/ButtonJoin/ButtonJoin'
import {ColorInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/ColorInput'
import {FontInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/FontInput'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {StringInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/StringInput'
import {TextAlignInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/TextAlignInput'
import {DefaultBlockConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function ButtonJoinConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} =
    useFormicForm<ButtonJoinConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <FontInput
          value={values.font}
          name={'font'}
          label={t('templateEditor.fontLabel')}
          setFieldValue={setFieldValue}
        />
        <StringInput
          value={values.text}
          name={'text'}
          label={t('templateEditor.textLabel')}
          placeholder={t('templateEditor.buyNowPlaceholder')}
          setFieldValue={setFieldValue}
        />
        <SliderInput
          value={values.fontSize}
          name={'fontSize'}
          label={t('templateEditor.textSizeLabel')}
          setFieldValue={setFieldValue}
          max={8}
          min={0.5}
          step={0.1}
        />
        <ColorInput
          value={values.textColor}
          name={'textColor'}
          label={t('templateEditor.textColorLabel')}
          setFieldValue={setFieldValue}
        />

        <TextAlignInput
          value={values.textAlign}
          name={'textAlign'}
          label={t('templateEditor.textAlignLabel')}
          setFieldValue={setFieldValue}
        />

        <ColorInput
          value={values.backgroundColor}
          name={'backgroundColor'}
          label={t('templateEditor.buttonColorLabel')}
          setFieldValue={setFieldValue}
        />

        <SliderInput
          value={values.width}
          name={'width'}
          label={t('templateEditor.buttonWidthLabel')}
          setFieldValue={setFieldValue}
          max={100}
          min={1}
          step={1}
        />

        <SliderInput
          value={values.height}
          name={'height'}
          label={t('templateEditor.buttonHeightLabel')}
          setFieldValue={setFieldValue}
          max={200}
          min={1}
          step={1}
        />

        <DefaultBlockConfig values={values} setFieldValue={setFieldValue} />
      </form>
    </>
  )
}
